import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  maxHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  background: theme.palette.background.main,
  overflowY: "hidden",
}));

const CustomizedBackground = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  minHeight: theme.spacing(16),
}));

const CustomizedOverlay = styled(Box)(({ theme }) => ({
  height: theme.spacing(1),
  marginBottom: theme.spacing(15),
  width: "100%",
  position: "absolute",
  top: 64,
  left: 0,
  backgroundImage: `linear-gradient( ${theme.palette.primary.main},  transparent)`,
  zIndex: 998,
}));

const Portal = props => {
  const { children, displayHeader, ...other } = props;

  return (
    <CustomizedComponent {...other}>
      {displayHeader && <CustomizedBackground />}
      {displayHeader && <CustomizedOverlay />}
      {children}
    </CustomizedComponent>
  );
};

export default Portal;
